import type PickupLocation from '~/types/PickupLocation';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type PickupsState = {
  readonly buildingLocationTypes: PickupLocation[];
  readonly carrier: Maybe<string>;
  readonly carrierAccountId: Maybe<string>;
  readonly confirmationCode: Maybe<string>;
  readonly isLoading: boolean;
  readonly pickupDate: Maybe<string>;
  readonly pickupPending: boolean;
  readonly pickupReadyByTime: Maybe<string>;
  readonly pickupSuccess: boolean;
  readonly pickupsLocation: Maybe<PickupLocation>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly serviceLevelInfo: any;
  readonly timeZone: Maybe<string>;
  readonly totalTransactions: number;
  readonly totalWeight: number;
  readonly transactionObjectIds: string[];
};

const initialState: PickupsState = {
  buildingLocationTypes: [],
  carrier: null,
  carrierAccountId: null,
  confirmationCode: null,
  isLoading: true,
  pickupDate: null,
  pickupPending: false,
  pickupReadyByTime: null,
  pickupSuccess: false,
  pickupsLocation: null,
  serviceLevelInfo: {},
  timeZone: null,
  totalTransactions: 0,
  totalWeight: 0,
  transactionObjectIds: [],
};

const pickupsReducer = (state: PickupsState = initialState, action: ActionTypes): PickupsState => {
  switch (action.type) {
    case ActionKeys.PICKUPS_FETCH_TRANSACTIONS:
      return {
        ...state,
        carrier: action.payload.carrier,
      };
    case ActionKeys.PICKUPS_FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        serviceLevelInfo: action.payload.serviceLevelInfo,
        totalTransactions: action.payload.totalTransactions,
        totalWeight: action.payload.totalWeight,
        transactionObjectIds: action.payload.transactionObjectIds,
      };
    case ActionKeys.PICKUPS_FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        carrierAccountId: action.payload.carrierAccountId,
      };
    case ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_SUCCESS:
      return {
        ...state,
        buildingLocationTypes: action.payload.map(
          (val) => ({ name: val.name, value: val.name }), // Yes, name in both cases
        ),
      };
    case ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST:
      return {
        ...state,
        pickupPending: true,
      };
    case ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_SUCCESS:
      return {
        ...state,
        confirmationCode: action.payload.confirmationCode,
        pickupDate: action.payload.pickupDate,
        pickupPending: false,
        pickupReadyByTime: action.payload.pickupReadyByTime,
        pickupSuccess: true,
        timeZone: action.payload.timeZone,
      };
    case ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_ERROR:
      return {
        ...state,
        pickupPending: false,
        pickupSuccess: false,
      };
    case ActionKeys.PICKUPS_RESET:
      return {
        ...state,
        confirmationCode: null,
        pickupDate: null,
        pickupPending: false,
        pickupReadyByTime: null,
        pickupSuccess: false,
        timeZone: null,
      };
    default:
      return state;
  }
};

export default pickupsReducer;
